import { DocumentNoteHeader } from "../../../AdminLayout_Style";
import {
  ActionButton,
  BlogListWrapper,
  BlogTable,
  BlogTd,
  BlogTh,
} from "../../../style/admin/Blog_Style";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IPageGetPage } from "../../../models/page";
import UserService from "../../../services/api/user.service";
import { IUser } from "../../../models/user";
import UserTransactionModal from "./UserTransactionModal";

const UserList = () => {
  const [pages, setPages] = useState<IUser[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [keySearch, setKeySearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const [openTransactionModal, setOpenTransactionModal] = useState(false);

  const [selectedUserId, setSelectedUserId] = useState<string>();

  const navigate = useNavigate();

  const getPage = async (pageNumber: number) => {
    const data: IPageGetPage = {
      CurrentPage: pageNumber,
      PageSize: pageSize,
      KeySearch: keySearch,
    };

    const res = await UserService.getPage(data);

    if (res.success) {
      setPages(res.items || []);
      setTotalCount(res.totalCount);
      // sửa theo response API của bạn
      setTotalPage(res.totalPages || 1);

      // hoặc nếu API trả totalRecords:
      // setTotalPage(Math.ceil(res.totalRecords / pageSize));
    }
  };

  const navButtonStyle = (disabled: boolean) => ({
    height: "44px",
    padding: "0 18px",
    borderRadius: "14px",
    border: disabled ? "1px solid #e5e7eb" : "1px solid #2563eb",
    background: disabled
      ? "#f3f4f6"
      : "linear-gradient(135deg, #2563eb, #3b82f6)",
    color: disabled ? "#9ca3af" : "#fff",
    fontWeight: 600,
    fontSize: "14px",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    boxShadow: disabled ? "none" : "0 6px 16px rgba(37,99,235,0.25)",
  });

  useEffect(() => {
    getPage(currentPage);
  }, [currentPage]);

  return (
    <>
      <DocumentNoteHeader>
        <h3>Danh sách User - Tổng {totalCount} </h3>
      </DocumentNoteHeader>

      <BlogListWrapper>
        <BlogTable>
          <thead>
            <tr>
              <BlogTh>#</BlogTh>
              <BlogTh>Tên</BlogTh>
              <BlogTh>Email</BlogTh>
              <BlogTh>Thao tác</BlogTh>
            </tr>
          </thead>

          <tbody>
            {pages.map((page, index) => (
              <tr key={page.id}>
                <BlogTd>{(currentPage - 1) * pageSize + index + 1}</BlogTd>

                <BlogTd>{page.fullName}</BlogTd>

                <BlogTd>{page.email}</BlogTd>

                <BlogTd>
                  <ActionButton
                    onClick={() => {
                      setSelectedUserId(page.id);
                      setOpenTransactionModal(true);
                    }}>
                    Xem danh sách File
                  </ActionButton>
                </BlogTd>
              </tr>
            ))}
          </tbody>
        </BlogTable>
        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            marginTop: "28px",
            flexWrap: "wrap",
          }}>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            style={navButtonStyle(currentPage === 1)}>
            ← Previous
          </button>

          {(() => {
            const paginationItems: (number | string)[] = [];

            const startPages = [1, 2, 3];
            const endPages = [totalPage - 2, totalPage - 1, totalPage];

            for (let i = 1; i <= totalPage; i++) {
              const isStartPage = startPages.includes(i);
              const isEndPage = endPages.includes(i);
              const isCurrentPage =
                i >= currentPage - 1 && i <= currentPage + 1;

              if (isStartPage || isEndPage || isCurrentPage) {
                paginationItems.push(i);
              }
            }

            // remove duplicate
            const uniquePages = Array.from(new Set(paginationItems)).sort(
              (a, b) => Number(a) - Number(b),
            );

            const finalItems: (number | string)[] = [];

            uniquePages.forEach((page, index) => {
              if (index > 0) {
                const prev = Number(uniquePages[index - 1]);

                if (Number(page) - prev > 1) {
                  finalItems.push("...");
                }
              }

              finalItems.push(page);
            });

            return finalItems.map((item, index) => {
              if (item === "...") {
                return (
                  <span
                    key={`ellipsis-${index}`}
                    style={{
                      padding: "0 6px",
                      color: "#6b7280",
                      fontWeight: 600,
                    }}>
                    ...
                  </span>
                );
              }

              const isActive = currentPage === item;

              return (
                <button
                  key={item}
                  onClick={() => setCurrentPage(Number(item))}
                  style={{
                    minWidth: "42px",
                    height: "42px",
                    borderRadius: "12px",
                    border: isActive
                      ? "1px solid #2563eb"
                      : "1px solid #e5e7eb",
                    background: isActive ? "#2563eb" : "#fff",
                    color: isActive ? "#fff" : "#111827",
                    fontWeight: isActive ? 700 : 500,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: isActive
                      ? "0 4px 12px rgba(37,99,235,0.25)"
                      : "none",
                  }}>
                  {item}
                </button>
              );
            });
          })()}

          <button
            disabled={currentPage === totalPage}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            style={navButtonStyle(currentPage === totalPage)}>
            Next →
          </button>
        </div>
      </BlogListWrapper>
      <UserTransactionModal
        open={openTransactionModal}
        userId={selectedUserId}
        onClose={() => {
          setOpenTransactionModal(false);
          setSelectedUserId(undefined);
        }}
      />
    </>
  );
};

export default UserList;
